import { BaseModel, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import ArticleFilterGroup from './ArticleFilterGroup'

export default class ArticleFilters extends BaseModel {
  static override constructorName = 'ArticleFilters'

  rubrics: ArticleFilterGroup = new ArticleFilterGroup(null)
  audiences: ArticleFilterGroup = new ArticleFilterGroup(null)
  tags: ArticleFilterGroup = new ArticleFilterGroup(null)
  'popular_tags': ArticleFilterGroup = new ArticleFilterGroup(null)

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      this.rubrics = new ArticleFilterGroup(data.rubrics)
      this.audiences = new ArticleFilterGroup(data.audiences)
      this.tags = new ArticleFilterGroup(data.tags)
      this.popular_tags = new ArticleFilterGroup(data.popular_tags)
    }
  }
}

registerModel(ArticleFilters)
